import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FullScreenLoader } from "../../components";
import { LOGIN_PATH, PEOPLE_SCREEN_PATH, SIGNUP_PATH } from "../../utils/constants/routes";
import { useSelector } from "react-redux";

const Loading = () => {

  const navigate = useNavigate();
  const checkLoginSelector = useSelector(state=> state.checkLogin)

  const isLoggedIn = async () => {
    navigate( SIGNUP_PATH )
  }

  if( checkLoginSelector?.payload?.status ){
    navigate( PEOPLE_SCREEN_PATH )
  }


  if( checkLoginSelector?.error?.status === false ){
    navigate( LOGIN_PATH )
  }

  useEffect(() => {

    isLoggedIn()

  },[]);

  return <FullScreenLoader />
};

export default Loading;
